/**
 * LLM-9F — conversation-bound forget flow helpers (reuse LLM-9E session pattern).
 */

export const MEMORY_ITEM_UI_STATE = {
  IDLE: "IDLE",
  REQUESTING: "REQUESTING",
  AWAITING_CONFIRMATION: "AWAITING_CONFIRMATION",
  CONFIRMING: "CONFIRMING",
  CANCELLED: "CANCELLED",
  EXECUTED: "EXECUTED",
  UNCERTAIN: "UNCERTAIN",
  ERROR: "ERROR",
};

export const FORGET_ALL_UI_STATE = {
  IDLE: "IDLE",
  DIALOG_OPEN: "DIALOG_OPEN",
  REQUESTING: "REQUESTING",
  AWAITING_CONFIRMATION: "AWAITING_CONFIRMATION",
  CONFIRMING: "CONFIRMING",
  CANCELLED: "CANCELLED",
  EXECUTED: "EXECUTED",
  UNCERTAIN: "UNCERTAIN",
  ERROR: "ERROR",
};

export { CONFIRM_REPLY, REJECT_REPLY, buildSessionMessageRequest, createClientMessageId } from "@/lib/memorySuggestionPromotion";
